import React, {useCallback, useMemo, useState} from 'react';
import _ from 'lodash';
import {atom} from 'nanostores';
import {useStore} from '@nanostores/react';
import {Box, Divider, IconButton, Modal, Stack, Typography, useMediaQuery, useTheme} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useHotkey, useObjectMemo} from '../util/react_hooks.js';

const $modalContent = atom(null);

export const openModal = content=>$modalContent.set(content);

export const closeModal = ()=>$modalContent.set(null);

const MODAL_BOX_STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid rgba(0, 0, 0, 0.2)',
    boxShadow: 24,
    borderRadius: 2,
    gap: 0,
};

const ModalHeader = props=>{
    let {onClose, children} = props;
    return <Stack direction="row" gap={1} alignItems="center" padding={1}>
      <IconButton onClick={onClose} size="small">
        <CloseIcon/>
      </IconButton>
      {children}
    </Stack>;
};

export const ModalComp = ()=>{
    let theme = useTheme();
    let sm = useMediaQuery(theme.breakpoints.down('sm'));
    let modalContent = useStore($modalContent);
    let close = useCallback(()=>{
        modalContent?.onClose?.();
        closeModal();
    }, [modalContent]);
    let content = useMemo(()=>{
        if (!modalContent)
            return null;
        if (React.isValidElement(modalContent))
            return void modalContent;
        let {header, onClose, content} = modalContent;
        return <>
          {header&&<>
            <ModalHeader onClose={()=>(onClose?.(), $modalContent.set(null))}>
              {_.isString(header) ? <Typography variant="h5">{header}</Typography> : header}
            </ModalHeader>
            <Divider/>
          </>}
          <Box padding={2} sx={{overflowY: 'auto', maxHeight: '70vh'}}>
            {content}
          </Box>
        </>;
    }, [modalContent]);
    useHotkey('Esc', close, !!modalContent);
    return <Modal open={!!modalContent} onClose={()=>$modalContent.set(null)}>
      <Stack sx={{...MODAL_BOX_STYLE, ...modalContent?.size=='lg'&&{width: 700}, ...sm&&{width: '90%'}}}>
        {content}
      </Stack>
    </Modal>;
};
